import {useContext, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import Cookies from 'js-cookie'
import {AuthContext} from 'App'
import {signIn, SignInParams} from 'api/auth'
import {Button} from 'components/Button'
import styles from './index.module.css'

export const SignIn = () => {
  const {setIsSignedIn, setCurrentUser} = useContext(AuthContext);
  const [signInParams, setSignInParams] = useState<SignInParams>({
    login: '',
    password: '',
  })

  const navigate = useNavigate();

  const handleSignInSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await signIn(signInParams);
      if (res.status === 200) {
        Cookies.set('_access_token', res.headers['access-token']);
        Cookies.set('_client', res.headers['client']);
        Cookies.set('_uid', res.headers['uid']);

        setIsSignedIn(true);
        setCurrentUser(res.data.data);

        navigate('/');
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div className={styles.formContainer} >
        <p>サインイン</p>
        <form className={styles.form} onSubmit={handleSignInSubmit}>
          <label>
            <input
              type='text'
              id='login'
              name='login'
              value={signInParams.login}
              placeholder='ユーザ名またはメールアドレス'
              onChange={(e) => setSignInParams({
                ...signInParams,
                login: e.target.value
              })}
            />
          </label>
          <label>
            <input
              type='password'
              id='password'
              name='password'
              value={signInParams.password}
              placeholder='パスワード'
              onChange={(e) => setSignInParams({
                ...signInParams,
                password: e.target.value
              })}
            />
          </label>
          <Button primary width='Full'>ログイン</Button>
        </form>
        <Button type='button' secondary width='Full' onClick={() => navigate('/signup')}>サインアップへ</Button>
      </div>
    </>
  );
};
